import { useLocale } from "@reco/shared/src/composables/useLocale";
import { Feature } from "~/composables/FeatureToggle/Feature";

type RuntimeConfigFeature = string | string[] | boolean | number;

export function useFeatureToggle() {
  const runtimeConfig = useRuntimeConfig();

  const featuresPerLocale = ref(new Map<string, Map<Feature, boolean>>());

  const localeStore = useLocale();
  const { query } = useRoute();

  function isFeatureEnabled(feature: Feature): boolean {
    const queryFeatValue = Array.isArray(query[feature]) ? query[feature][0] : query[feature];

    if (queryFeatValue) {
      if (queryFeatValue.toLowerCase() === "true") {
        return true;
      } else if (queryFeatValue.toLowerCase() === "false") {
        return false;
      }
    }

    return loadValueFromConfig(localeStore.locale.value, feature);
  }

  function loadValueFromConfig(localeStr: string, feature: Feature): boolean {
    let enabled: boolean | undefined = undefined;

    let featureMap: Map<Feature, boolean> | undefined = featuresPerLocale.value.get(localeStr);

    if (featureMap) {
      enabled = featureMap.get(Feature[feature as keyof typeof Feature]);

      if (enabled !== undefined) {
        return enabled;
      }
    } else {
      featureMap = new Map<Feature, boolean>();
      featuresPerLocale.value.set(localeStr, featureMap);
    }

    const rawValue = runtimeConfig.public[feature] as RuntimeConfigFeature;

    if (typeof rawValue === "boolean") {
      enabled = rawValue;
    } else {
      let enabledPerLocale: string[] = [];

      if (Array.isArray(rawValue)) {
        enabledPerLocale = rawValue;
      } else if (typeof rawValue === "string") {
        enabledPerLocale = rawValue.split(",");
      }

      enabled = enabledPerLocale.includes(localeStr);
    }

    featureMap.set(Feature[feature as keyof typeof Feature], enabled);

    return enabled;
  }

  return {
    isFeatureEnabled,
  };
}
